(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const resetAll = [];
  document.querySelectorAll('.helix, .mini-helix').forEach(dna => {
    const area = dna.closest('.hero-art, .genotype');
    if (!area) return;
    dna.classList.add('dna-interactive');
    let frame = null;
    const enabled = () => hoverPointer.matches && !reducedMotion.matches && !document.body.classList.contains('paused');
    const reset = () => {
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
      dna.style.setProperty('--pointer-x', '0px');
      dna.style.setProperty('--pointer-y', '0px');
      dna.style.setProperty('--pointer-turn', '0deg');
      dna.style.setProperty('--pointer-scale', '1');
    };
    resetAll.push(reset);
    area.addEventListener('pointermove', event => {
      if (event.pointerType !== 'mouse' || !enabled()) return;
      const bounds = area.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const x = Math.max(-1, Math.min(1, (event.clientX - bounds.left) / bounds.width * 2 - 1));
      const y = Math.max(-1, Math.min(1, (event.clientY - bounds.top) / bounds.height * 2 - 1));
      if (frame !== null) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = null;
        if (!enabled()) { reset(); return; }
        dna.style.setProperty('--pointer-x', `${x * 18}px`);
        dna.style.setProperty('--pointer-y', `${y * 12}px`);
        dna.style.setProperty('--pointer-turn', `${x * 9}deg`);
        dna.style.setProperty('--pointer-scale', '1.045');
      });
    });
    area.addEventListener('pointerleave', reset);
    area.addEventListener('pointercancel', reset);
  });
  const reset = () => resetAll.forEach(fn => fn());
  reducedMotion.addEventListener('change', reset);
  hoverPointer.addEventListener('change', reset);
  document.getElementById('motion')?.addEventListener('click', reset);
  window.addEventListener('blur', reset);
})();
